import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f4f4ef;
  padding: 20px;
  border-radius: 4px;
  width: 130px;
  margin: 20px auto;
  border: 1px solid #acbebe;
`;

export const Title = styled.h1`
  color: #20232a;
  font-family: "LXGW Marker Gothic", sans-serif;
  font-size: 13px;
  margin: 0;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
`;

export const Number = styled.p`
  font-family: "LXGW WenKai TC", cursive;
  color: #20232a;
  font-size: 30px;
  margin: 12px 0;
  font-weight: 800;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 6px;
  width: 100%;
`;

export const StyledButton = styled.button`
  color: #f4f4ef;
  border: none;
  flex: 1;
  padding: 8px 0;
  font-size: 15px;
  border-radius: 2px;
  cursor: pointer;
  background-color: ${(props) =>
    props.type === "increment" ? "#99c1c1ff" : "#981720ff"};

  color: ${(props) => (props.type === "increment" ? "#20232A" : "#F4F4EF")};

  &:active {
    opacity: 0.8;
    transform: translateY(1px);
  }
`;
